<!--
create by melody on 2018/11/1
description:修改密码
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <div class="info-container">
             <el-form :model="changeForm" status-icon :rules="changeRules" ref="changeForm" label-width="140px" class="demo-ruleForm">
                <el-form-item :label="$t('m.oldPwd')" prop="oldPassword" style="width: 460px">
                    <el-input type="password" v-model="changeForm.oldPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('m.newPwd')" prop="newPassword" style="width: 460px">
                    <el-input type="password" v-model="changeForm.newPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('m.confirmPwd')" prop="newPasswordRe" style="width: 460px">
                    <el-input type="password" v-model="changeForm.newPasswordRe" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item style="width: 400px">
                    <el-button type="primary" @click="changePwd()">{{$t('m.sure')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
let Base64 = require('js-base64').Base64
export default {
    data() {
        let validatePass1 = (rule, value, callback) => {
            if (this.changeForm.newPassword !== '') {
                this.$refs.changeForm.validateField('newPassword');
                callback();
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (this.changeForm.oldPassword && value == this.changeForm.oldPassword) {
                callback(new Error(this.$t('m.pwdMessage1')));
            } else if (this.changeForm.newPasswordRe !== '') {
                this.$refs.changeForm.validateField('newPasswordRe');
                callback();
            } else {
                callback();
            }
        };
        let validatePass3 = (rule, value, callback) => {
            if (this.changeForm.newPassword && value !== this.changeForm.newPassword) {
                callback(new Error(this.$t('m.pwdMessage2')));
            } else {
                callback();
            }
        };
        let passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8,15}$/;
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.ACCOUT_MANAGE'),
                thirdTitle: this.$t('m.CHANGE_PASSWORD')
            },
            infoList:[],
            changeForm: {
                oldPassword: '',
                newPassword: '',
                newPasswordRe: ''
            },
            changeFormEncode: {
                oldPassword: '',
                newPassword: '',
                newPasswordRe: ''
            },
            changeRules: {
                oldPassword: [{
                        required: true,
                        message: this.$t("m.inputOldPwd"),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass1,
                        trigger: 'blur'
                    }
                ],
                newPassword: [{
                        required: true,
                        message: this.$t("m.inputNewPwd"),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass2,
                        trigger: 'blur'
                    }
                ],
                newPasswordRe: [{
                        required: true,
                        message: this.$t("m.inputConfirmPwd"),
                        trigger: 'blur'
                    },
                    {
                        pattern: passwordReg,
                        message: this.$t('m.inputPwdRule'),
                        trigger: 'blur'
                    },
                    {
                        validator: validatePass3,
                        trigger: 'blur'
                    }
                ]
            },
        }
    },
    methods: {
        changePwd () {
            this.$refs['changeForm'].validate((valid) => {
                if (valid) {
                    this.changeFormEncode.oldPassword = Base64.encode(this.changeForm.oldPassword)
                    this.changeFormEncode.newPassword = Base64.encode(this.changeForm.newPassword)
                    this.changeFormEncode.newPasswordRe = Base64.encode(this.changeForm.newPasswordRe)
                    this.$commonFunc.commonRequest('post', '/system/user/updatePassword', 'changePwd', this.changeFormEncode)
                        .then(res => {
                            this.$message({
                                message: this.$t('m.changePwdSuc'),
                                type: 'success'
                            });
                            this.changeForm = {
                                oldPassword: '',
                                newPassword: '',
                                newPasswordRe: ''
                            }
                            this.$refs['changeForm'].clearValidate()
                        })
                        .catch(res => {
                            this.$message.error(res.message)
                        })
                } else {
                    return false
                }
            })
        }
    }
}
</script>
<style scoped>
.info-container {
    width: 600px;
    margin: 80px auto;
    color: rgb(44, 62, 80);
}
</style>


// WEBPACK FOOTER //
// src/pages/account/ChangePassword.vue